import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd/message";
import { AppsService } from "src/app/shared/services/apps.service";

@Component({
  selector: "app-vehicle-asgnment",
  templateUrl: "./vehicle-asgnment.component.html",
  styleUrls: ["./vehicle-asgnment.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VehicleAsgnmentComponent implements OnInit {
  clntDtls: any;
  tntLst: any = [];
  selectedtenant: any;
  vendorList: any = [];
  selectedvndr: any;
  vehctgryLst: any = [];
  selectedctgry: any;
  opensldr: boolean = false;
  fltrData: any = [];
  vhcleslst: any = [];
  showLdr: boolean;
  vhclslstcolumnDefs: any = [];
  ssList: any;
  asrtList: any;
  disabled: boolean = false;
  errMsg: any;
  ss_id;
  veh_id;
  userDtls: any;
  clap_in: any;
  ShowClap: boolean;
  showVndr: boolean;
  constructor(private apiSrvc: AppsService, private message: NzMessageService) {
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    this.tntLst = this.clntDtls[0].tnts;
    this.selectedtenant = this.tntLst[0].tnt_id;
    this.userDtls = JSON.parse(localStorage.getItem("wto_w_user"));
    this.clap_in = this.userDtls.clap_in;
    if (this.clap_in == 1) {
      this.ShowClap = true;
      this.selectedvndr = 0;
    }
  }

  ngOnInit(): void {
    this.getVendors();
    this.selectedctgry = 0;
    this.getvehicles();
    this.getSSList();
  }
  getVendors() {
    if (this.userDtls.dsgns_id == 1000032) {
      this.selectedvndr = this.userDtls.vndr_id;
      this.showVndr = true;
      if (this.selectedvndr && this.showVndr) {
        this.apiSrvc
          .get(`billing/vendors/list/${this.selectedvndr}/byId`)
          .subscribe(
            (res) => {
              if (res["status"] == 200) {
                this.vendorList = res["data"];
              }
            },
            (err) => {}
          );
      }
    } else if (this.clap_in == 0 || this.clap_in == 2) {
      this.vendorList = [];
      this.selectedvndr = 0;
      this.getvehicles();
    } else {
      this.apiSrvc
        .get(`billing/vehicle-wise/vendors/list/${this.selectedtenant}`)
        .subscribe(
          (res) => {
            if (res["status"] === 200) {
              this.vendorList = res["data"];
              this.selectedvndr = this.vendorList[0].vndr_id;
              this.getvehicles();
            }
          },
          (err) => {}
        );
    }
  }
  getVhcleCtgry = () => {
    this.apiSrvc
      .get(`drivers/vehicles/category/${this.selectedtenant}`)
      .subscribe(
        (res) => {
          this.vehctgryLst = res["data"];
        },
        (err) => {}
      );
  };
  ontntSelect(value) {
    this.selectedtenant = value;
    this.getVendors();
    this.getVhcleCtgry();
    this.getvehicles();
    this.getSSList();
  }
  onvndrSelect(value) {
    this.selectedvndr = value;
    this.getvehicles();
  }
  onctgrySelect(value) {
    this.selectedctgry = value;
    this.getvehicles();
  }
  openSlider() {
    this.opensldr = true;
  }
  closeSideBar() {
    this.opensldr = false;
    this.getvehicles();
  }
  getvehicles() {
    var fltrData = [
      {
        selectedtenant: this.selectedtenant,
        selectedvndr: this.selectedvndr,
        selectedctgry: 0,
      },
    ];

    this.apiSrvc.post(fltrData, "drivers/vehicles/asgndvehicles").subscribe(
      (res) => {
        if (res["status"] == 200) {
          this.vhcleslst = res["data"];
          this.asrtList = this.vhcleslst;
          this.showLdr = false;
          console.log(res);
          console.log(this.vhcleslst);
          for (let v = 0; v < this.vhcleslst.length; v++) {
            if (this.vhcleslst[v].asrtglblId === 1) {
              this.vhcleslst[v].icon_path = this.vhcleslst[v].icon_path + "_r";
            } else if (this.vhcleslst[v].asrtglblId === 2) {
              this.vhcleslst[v].icon_path = this.vhcleslst[v].icon_path + "_o";
            } else {
              this.vhcleslst[v].icon_path = this.vhcleslst[v].icon_path + "_p";
            }
          }
          let counter = 0;
          this.vhcleslst.filter((k) => {
            // counter1 = 0;
            k["sno"] = ++counter;
          });
          this.vhclslstcolumnDefs = [
            {
              headerName: "S.No",
              field: "sno",
              alignment: "center",
              width: 60,
              filter: false,
            },
            { headerName: "ULB Name", alignment: "left", field: "ulb_nm" },
            // { headerName: 'District', alignment: 'left', field: 'dstrct_nm' },
            { headerName: "Vehicle No", alignment: "left", field: "asrt_nm" },
            {
              headerName: "Category",
              field: "asrt_ctgry_nm",
              alignment: "left",
            },
            { headerName: "Group", alignment: "left", field: "asrt_grp_nm" },
            {
              headerName: "Assigned User Name",
              alignment: "left",
              field: "usr_nm",
            },
            {
              headerName: "Contact Number",
              alignment: "center",
              field: "mobile_nu",
            },
            {
              headerName: "Assigned On",
              alignment: "center",
              field: "effct_ts",
            },
            // { headerName: 'End Fence', field: 'endFence', alignment: 'center' }
          ];
        }
      },
      (err) => {}
    );
  }
  getSSList() {
    this.apiSrvc
      .get(`drivers/vehicles/getUsers/${this.selectedtenant}`)
      .subscribe(
        (res) => {
          this.ssList = res["data"];
        },
        (err) => {}
      );
  }
  saveasgnmnt() {
    var postData = {
      asrt_id: this.veh_id,
      usr_id: this.ss_id,
      tnt_id: this.selectedtenant,
    };
    this.apiSrvc.post(postData, "drivers/vehicles/assgn").subscribe(
      (res) => {
        if (res["status"] == 200) {
          this.createMessage(
            "success",
            "Sucessfully Assigned Vehicle(s) For Sanitory Secratory!!"
          );
        } else {
          this.createMessage(
            "warning",
            "Failed to Assigned Vehicle(s) For Sanitory Secratory!!"
          );
        }
      },
      (err) => {}
    );
    this.getvehicles();
  }
  createMessage(type: string, msg: string): void {
    this.message.create(type, msg);
  }
  onvehiclesselect(value) {
    if (value.length > 4) {
      this.disabled = true;
      this.errMsg = "Maximum Vehicle Limit is 5 for each Sanitory Secratory";
    }
  }
}
